export type FindockProcessors = 'FinDock-Vipps' | 'PaymentHub-Stripe' | 'FinDock-for-Norway'
export type FindockTargets = 'VippsAnimaNorway'
export type FindockPaymentMethods = 'Vipps' | 'CreditCard' | 'AvtaleGiro'

export interface FindockPaymentIntentResponse {
  RedirectURL: string
  Id: string
  Settings?: {
    SourceConnector: 'PaymentHub'
    ProcessingType: 'Default'
  }
  PaymentMethod?: {
    Target: FindockTargets
    Processor: FindockProcessors
    Name: FindockPaymentMethods
    Parameters: {
      description: 'Fastgiver Anima'
      mobileNumber: string
    }
  }
}

// https://docs.findock.com/configuring-vipps
type PaymentMethodVipps = {
  Name: 'Vipps'
  Processor: 'FinDock-Vipps'
  Parameters: {
    description: string
    // Used to autofill out the mobile number
    mobileNumber?: string
    // I think there is a default one in Salesforce
    merchantAgreementURL?: string
    productName?: string
  }
}

type PaymentMethodAvtaleGiro = {
  Name: 'AvtaleGiro'
  Processor: 'FinDock-for-Norway'
  Target: 'AvtaleGiro DNB'
  Parameters: {
    // Description of the payment for the payer’s bank.
    description: string
    // Factor to calculate the amount limit (Amount * factor). If no factor is submitted, the amount limit will be set to the default of 10000NOK. The value may be changed by the payer.
    amountLimitFactor?: number
    // Sets the default notification setting, which the payer may change. If true, the payer will receive notification of new AvtaleGiro payment claims.
    notification?: boolean
  }
}

// https://docs.findock.com/payment-processors/stripe
type PaymentMethodCreditCard = {
  Name: 'CreditCard'
  Processor: 'PaymentHub-Stripe'
  Parameters: {
    // Description of the payment for the payer’s bank.
    description: string
    itemName?: string
  }
}

interface PaymentIntentSalesforceFields {
  utm_source__c?: string
  utm_medium__c?: string
  utm_campaign__c?: string
  utm_content__c?: string
  utm_term__c?: string
  Email_receipt_sent__c?: boolean
}

export interface SalesforceFieldsRecurring extends PaymentIntentSalesforceFields {
  Origin__c?: string
}
export interface SalesforceFieldsOneTime extends PaymentIntentSalesforceFields {
  cpm__Origin__c?: string
}

// 'One-time', 'Quarterly', 'Twice a year',
// FinDock currently allows you to create Daily, Weekly, Monthly or Yearly intervals for Vipps. This is based on the Recurring Frequency in the API.
// https://docs.findock.com/payment-processors/using-vipps
export const findockFrequencyOptions = ['Monthly', 'Yearly'] as const
export type FindockFrequency = (typeof findockFrequencyOptions)[number]

export interface FindockPaymentIntentRequest {
  SuccessURL: string
  FailureURL: string
  Origin?: string
  CampaignId?: string
  Payer: {
    Contact: {
      SalesforceFields: {
        FirstName: string
        LastName: string
        Email: string
        Phone?: string
        Phone_cellphone__c?: string
        Phone_calling_code__c?: string
        Phone_calling_code_cellphone__c?: string
      }
    }
    Account?: {
      RecordTypeName: 'Person'
      SalesforceFields: {
        Name: string
        Email__c: string
        Phone?: string
        Phone__c?: string
        PhoneCallingCode__c?: string
      }
    }
  }
  Recurring?: {
    Amount: number
    Frequency: FindockFrequency
    StartDate?: string
    SalesforceFields?: SalesforceFieldsRecurring
  }
  OneTime?: {
    Amount: number
    SalesforceFields?: SalesforceFieldsOneTime
  }
  PaymentMethod: PaymentMethodVipps | PaymentMethodAvtaleGiro | PaymentMethodCreditCard
  Settings: {
    SourceConnector: 'PaymentHub'
  }
}
